export default "__VITE_ASSET__CVwYWsxz__"